import React from 'react';
import { NavBar } from './components/NavBar';
import { Hero } from './components/Hero';
import { MilestonesStrip } from './components/MilestonesStrip';
import { FeaturedUpdate } from './components/FeaturedUpdate';
import { MapVisor } from './components/MapVisor';
import { CatastroMultiproposito } from './components/CatastroMultiproposito';
import { EscuelaIntercultural } from './components/EscuelaIntercultural';
import { AcuerdosPNN } from './components/AcuerdosPNN';
import { ColombiaEnMapas } from './components/ColombiaEnMapas';
import { DiplomadosVirtuales } from './components/DiplomadosVirtuales';
import { NewsGrid } from './components/NewsGrid';
import { ClosingCTA } from './components/ClosingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-bone text-charcoal font-sans selection:bg-clay selection:text-bone" data-id="element-0" data-mp="28u5uwe1s0p8m">
      <NavBar data-id="element-1" data-mp="23vuq4hqc94x9" />
      <main data-id="element-2" data-mp="23u9u0nodldxa">
        <Hero data-id="element-3" data-mp="23ujl6el5pr4k" />
        <MilestonesStrip data-id="element-4" data-mp="23v2sz2h3ez4v" />
        <FeaturedUpdate data-id="element-5" data-mp="3ijxq4swlw4ky" />
        <MapVisor data-id="element-6" data-mp="3ikh5q2ysagvt" />
        <CatastroMultiproposito data-id="element-7" data-mp="3ij652c0mxp8x" />
        <AcuerdosPNN data-id="element-8" data-mp="3ihv0i9zd8dgr" />
        <ColombiaEnMapas data-id="element-9" data-mp="3mlj6io8cn0zw" />
        <DiplomadosVirtuales data-id="element-10" data-mp="3mkrcviybbdc9" />
        <EscuelaIntercultural data-id="element-11" data-mp="3mjzpgvevclx2" />
        <NewsGrid data-id="element-12" data-mp="3rc9du70c5dx8" />
        <ClosingCTA data-id="element-13" data-mp="3rbrakqf99zft" />
      </main>
      <Footer data-id="element-14" data-mp="3rdkl4gszp3t3" />
    </div>;
}